import script from "./WorkHistoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkHistoryList.vue?vue&type=script&setup=true&lang=js"

import "./WorkHistoryList.vue?vue&type=style&index=0&id=21a3a297&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a3a297"]])

export default __exports__